export const MUNICIPAL_PROPERTY_SEARCH_DEBOUNCE_MS: number = 300;
